<template>
    <div class="">
        <input type="hidden" name="model" :value="JSON.stringify(list)">

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Liste</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label>Titel</label>
                    <input type="text" class="form-control" name="title" placeholder="Titel" v-model="list.title">
                </div>

                <div class="form-group">
                    <label>Typ</label>
                    <select class="form-control" v-model="list.config.type">
                        <option value="pharmacies">Apotheken</option>
                        <option value="pharmacies-wholesalers">Apotheken mit Großhandel (max. eine Liste)</option>
                        <option value="wholesaler-conditions">Großhändler mit Konditionen (max. eine Liste)</option>
                        <option value="pzn">PZN</option>
                        <option value="pzn-groups">PZN Gruppen</option>
                        <option value="universal-groups">Universal Gruppen</option>
                    </select>
                    <small class="form-text text-info"
                           v-if="['pharmacies-wholesalers', 'wholesaler-conditions'].includes(list.config.type)">
                        Die Liste der Großhandelsnummern befindet sich in der Vorlage auf dem zweiten Blatt.
                    </small>
                </div>

                <div class="form-group" v-if="list.config.type === 'pharmacies'">
                    <label>Datenquelle</label>
                    <select class="form-control" v-model="list.config.source">
                        <option value="custom">Manuell</option>
                        <option value="direktplus:all">DIREKTplus</option>
                        <option :value="contract.key" v-for="contract in crmContracts">
                            CRM Vertrag:
                            {{ contract.value }}
                        </option>
                        <option :value="'crm:wholesaler:' + wholesaler.id" v-for="wholesaler in wholesalersWithShort">
                            CRM GH:
                            {{ wholesaler.short }}
                        </option>
                    </select>
                </div>

                <div class="form-group" v-if="list.config.type === 'universal-groups'">
                    <label>Gruppen beziehen sich auf</label>
                    <select class="form-control" v-model="list.config.adasField">
                        <option value="bga">BGA</option>
                        <option value="pzn">PZN</option>
                        <option value="anbieter">Anbieter</option>
                        <option value="warengruppe">Warengruppe</option>
                        <option value="darreichungsform">Darreichungsform</option>
                    </select>
                </div>

                <div class="form-group" v-if="list.config.source === 'custom'">
                    <label>Liste hochladen</label>
                    <input type="file" class="form-control-file" accept=".xlsx,.xls" @change="upload"
                           ref="file">
                    <div v-if="errors" class="text-danger">
                        <ul>
                            <li v-for="error in errors">
                                <span :title="JSON.stringify(error.row)">Zeile {{ error.index + 1 }}:</span>
                                {{ error.message }}
                            </li>
                        </ul>
                    </div>
                    <div class="mt-1">
                        <a :href="templateUrl">
                            <small>
                                <i class="fas fa-fw fa-download"></i>
                                Download Vorlage
                            </small>
                        </a>
                        <a href="#" @click.prevent="add" v-if="['pharmacies', 'pzn'].includes(list.config.type)">
                            <small>
                                <i class="fas fa-fw fa-user-edit"></i>
                                Eintrag hinzufügen
                            </small>
                        </a>
                    </div>
                </div>

                <div class="mb-3">
                    <div v-if="contentLength">
                        {{ contentLength }} {{ unit }} ausgewählt
                        <a href="#" @click.prevent="itemsVisible = !itemsVisible"
                           v-if="['pharmacies', 'pzn'].includes(list.config.type)">
                            <i class="fas fa-fw" :class="{'fa-eye': !itemsVisible, 'fa-eye-slash': itemsVisible}"></i>
                        </a>
                        <table class="table table-sm table-bordered mt-2 mb-0"
                               v-if="itemsVisible && list.config.type === 'pharmacies'">
                            <thead>
                            <tr>
                                <th>BGA</th>
                                <th>Name</th>
                                <th>Ort</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in list.config.content">
                                <td>{{ item.bga }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.city }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <table class="table table-sm table-bordered mt-2 mb-0"
                               v-if="itemsVisible && list.config.type === 'pzn'">
                            <thead>
                            <tr>
                                <th>PZN</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="pzn in list.config.content">
                                <td>{{ pzn }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <br>
                        <small>
                            <a href="#" @click.prevent="list.config.content = contentDefault">Leeren</a>
                        </small>
                    </div>
                    <div v-else class="text-muted">
                        Noch keine Daten
                    </div>
                </div>

            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(list, 0, 2) }}</pre>
    </div>
</template>

<script>

export default {
    props: {
        listModel: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            list: this.listModel,
            itemsVisible: false,
            errors: null
        };
    },
    methods: {
        upload() {
            this.errors = null;
            const file = this.$refs.file.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const headers = {'Content-Type': 'multipart/form-data'};

            let endpoint;
            if (this.list.config.type === 'pharmacies') {
                endpoint = '/files/pharmacies';
            }
            if (this.list.config.type === 'pharmacies-wholesalers') {
                endpoint = '/files/pharmacies-wholesalers';
            }
            if (this.list.config.type === 'wholesaler-conditions') {
                endpoint = '/files/wholesaler-conditions';
            }
            if (this.list.config.type === 'pzn') {
                endpoint = '/files/pzn';
            }
            if (this.list.config.type === 'pzn-groups') {
                endpoint = '/files/pzn-groups';
            }
            if (this.list.config.type === 'universal-groups') {
                endpoint = '/files/universal-groups';
            }

            axios.post(endpoint, formData, {headers}).then((res) => {
                this.list.config.content = res.data;
            }).catch((error) => {
                const importError = error.response.data.import_errors || false;
                const updatedContent = error.response.data.data || false;
                if (importError) {
                    this.errors = error.response.data.errors;
                    // still override list content if available
                    if (updatedContent) {
                        this.list.config.content = error.response.data.data;
                    }
                } else {
                    console.log(error);
                    alert("Unbekannter Fehler");
                }

            }).finally(() => {
                this.$refs.file.value = '';
            });
        },
        add() {
            if (this.list.config.type === 'pharmacies') {
                const bgas = window.prompt('BGA');
                if (bgas) {
                    axios.get('/select/pharmacies/from-bgas?bgas=' + bgas).then((res) => {
                        const newPharmacies = res.data;
                        newPharmacies.forEach((newPharmacy) => {
                            if (newPharmacy.bga && !this.list.config.content.some(pharmacy => parseInt(pharmacy.bga) === parseInt(newPharmacy.bga))) {
                                this.list.config.content.push(newPharmacy);
                            }
                        });
                    });
                }
            }
            if (this.list.config.type === 'pzn') {
                const newPzns = window.prompt('PZN');
                if (newPzns) {
                    newPzns.split(',').forEach((newPzn) => {
                        if (!this.list.config.content.some(pzn => parseInt(pzn) === parseInt(newPzn))) {
                            this.list.config.content.push(newPzn);
                        }
                    });
                }
            }
        },
    },
    computed: {
        contentLength() {
            if (this.list.config.type === 'pharmacies' ||
                this.list.config.type === 'pharmacies-wholesalers' ||
                this.list.config.type === 'wholesaler-conditions' ||
                this.list.config.type === 'pzn') {
                return this.list.config.content.length;
            }
            if (this.list.config.type === 'pzn-groups' ||
                this.list.config.type === 'universal-groups') {
                return Object.keys(this.list.config.content).length;
            }
        },
        contentDefault() {
            if (this.list.config.type === 'pharmacies' ||
                this.list.config.type === 'pharmacies-wholesalers' ||
                this.list.config.type === 'wholesaler-conditions' ||
                this.list.config.type === 'pzn') {
                return [];
            }
            if (this.list.config.type === 'pzn-groups' ||
                this.list.config.type === 'universal-groups') {
                return {};
            }
        },
        unit() {
            if (this.list.config.type === 'pharmacies') {
                return 'Apotheken';
            }
            if (this.list.config.type === 'pharmacies-wholesalers') {
                return 'Apotheken mit Großhandel';
            }
            if (this.list.config.type === 'wholesaler-conditions') {
                return 'Großhändler';
            }
            if (this.list.config.type === 'pzn') {
                return 'PZN';
            }
            if (this.list.config.type === 'pzn-groups') {
                return 'PZN Gruppen';
            }
            if (this.list.config.type === 'universal-groups') {
                return 'Universal Gruppen';
            }
        },
        templateUrl() {
            if (this.list.config.type === 'pharmacies') {
                return '/files/Vorlage_Apotheken.xlsx';
            }
            if (this.list.config.type === 'pharmacies-wholesalers') {
                return '/files/Vorlage_Apotheken_GH.xlsx';
            }
            if (this.list.config.type === 'wholesaler-conditions') {
                return '/files/Vorlage_GH.xlsx';
            }
            if (this.list.config.type === 'pzn') {
                return '/files/Vorlage_PZN.xlsx';
            }
            if (this.list.config.type === 'pzn-groups') {
                return '/files/Vorlage_PZN_Gruppen.xlsx';
            }
            if (this.list.config.type === 'universal-groups') {
                return '/files/Vorlage_Universal_Gruppen.xlsx';
            }
        },
        wholesalersWithShort() {
            return this.options.wholesalers.filter((wholesaler) => !!wholesaler.short);
        },
        crmContracts() {
            if (window.coops.includes('migasa')) {
                return [
                    {
                        key: 'crm:contract:check',
                        value: 'Check'
                    },
                    {
                        key: 'crm:contract:preis',
                        value: 'Preis'
                    },
                    {
                        key: 'crm:contract:einkauf',
                        value: 'Einkauf'
                    },
                ];
            }

            return [
                {
                    key: 'crm:contract:kpvkv',
                    value: 'KPV und KV'
                },
                {
                    key: 'crm:contract:offizinplus',
                    value: 'OFFIZINplus'
                },
                {
                    key: 'crm:contract:abacus',
                    value: 'Datenlieferung ABACUS'
                },
                {
                    key: 'crm:contract:orifarm',
                    value: 'Datenlieferung Orifarm'
                },
                {
                    key: 'crm:contract:localseo',
                    value: 'Local SEO Service'
                },
                {
                    key: 'crm:contract:karten',
                    value: 'Impfzertifikat-Karten'
                },
                {
                    key: 'crm:contract:flyer',
                    value: 'Flyer'
                },
                {
                    key: 'crm:contract:audit',
                    value: 'Rechnungsprüfung'
                },
                {
                    key: 'crm:contract:wba',
                    value: 'Warenbezugsanalyse'
                },
            ];
        }
    },
    watch: {
        'list.config.type': function () {
            this.list.config.content = this.contentDefault;
            this.list.config.source = 'custom';
            this.list.config.adasField = 'bga';
        },
        'list.config.source': function () {
            this.list.config.content = this.contentDefault;
        }
    }
}
</script>
